import { EventBusEvents } from "@/enums/EventBusEvents"
import { eventBus } from "@/eventBus"
import utils from "@/utils"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import checkoutValidationMixin from "@/mixins/checkout-validation-mixin"

let cartSummaryMixin = {
    mixins: [currencyFilterMixin, checkoutValidationMixin],
    data: function () {
        return {
            isOpen: false
        }
    },
    computed: {
        slug() {
            return this.$route.params.slug
        },
        cart() {
            return this.$store.state.cart ? this.$store.state.cart : []
        },
        cartSections() {
            const sections = {}
            this.cart.forEach((item, i) => {
                const key = `${item.delivery_date}_${item.menu_id}`
                if (sections[key] == undefined) {
                    sections[key] = {
                        id: i,
                        menuId: item.menu_id,
                        items: [],
                        date: item.delivery_date
                    }
                }
                sections[key].items.push(item)
            })
            return Object.values(sections).sort((a, b) => a.id + b.id)
        },
        buttonText() {
            return this.isCheckoutPage ? "Place Order" : "Checkout"
        }
    },
    methods: {
        async checkout() {
            try {
                if (this.isCheckoutPage) {
                    this.$emit("checkout")
                } else {
                    this.$store.dispatch("sendMixpanelEvent", {
                        msg: "Click Checkout"
                    })

                    await this.validateCartMinimum()
                    await this.validateCart()
                    if (this.isResidential) {
                        let requiresAuthentication = true
                        if (this.$store.getters.isGuestCheckoutAvailable) {
                            if (!this.$store.state.temporaryFlag.isGuestCheckoutActive) {
                                const promise = utils.createPromise()
                                this.$emit("showGuestCheckoutModal", {
                                    resolve: promise.resolve
                                })
                                await promise.promise
                                requiresAuthentication = !this.$store.state.temporaryFlag.isGuestCheckoutActive
                            } else {
                                requiresAuthentication = false
                            }
                        }
                        if (requiresAuthentication) {
                            const promise = utils.createPromise()
                            eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW, {
                                resolve: promise.resolve
                            })
                            const verified = await promise.promise
                            if (!verified) {
                                return
                            }
                        }
                        const pathSuffix =
                            this.$route.meta.isEvent === true
                                ? `/event/${this.$route.params.eventId}`
                                : ""
                        this.$router.push({
                            path: `/${this.slug}/checkout${pathSuffix}`
                        })
                    } else {
                        this.$router.push({
                            path: `/${this.slug}/checkout`
                        })
                    }
                }
                return true
            } catch (e) {
                this.bugsnag.notify(e && e.message ? e.message : e)
                return false
            }
        },
        open() {
            this.isOpen = true
        },
        close() {
            this.isOpen = false
        }
    }
}

export default cartSummaryMixin